import React from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContext } from "react";

function Protected({ children }) {
  let { user } = useContext(AuthContext);
  if (user.role !== "ccaAdmin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
export default Protected;
